// See Mueller.Business.Models.HomeownerCase.CaseStatusCodes

export const PrimaryStatus = {
  OPEN: "OPEN",
  COMPLETED: "COMPLETED"
};

export const SecondaryStatus = {
  PENDING: "PENDING",
  PREASSIGNMENT: "PREASSIGNMENT",
  RECEIVED: "RECEIVED",
  SUBMITTED_FROM_FIELD: "SUBMITTED FROM FIELD",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  UNASSIGNED: "UNASSIGNED",
  COMPLETION_PENDING: "COMPLETION PENDING",
  QA: "QA",
  ORDER_PAYMENT_REQUIRED: "ORDER PAYMENT REQUIRED",
  ORDER_PAYMENT_PENDING: "ORDER PAYMENT PENDING",
  ORDER_PAYMENT_EXPIRED: "ORDER PAYMENT EXPIRED",
  AWAITING_FIELD_REPORT: "AWAITING_FIELD_REPORT",
  AWAITING_DATA: "AWAITING DATA",
  DATA_FAILED: "DATA FAILED",
};